// extracted by mini-css-extract-plugin
module.exports = {"content":"_dJj2nGgx","description":"_JQ_otuiJ","container":"_mTsKJ0lI","title":"_Y8BkOBf_"};